export default "__VITE_ASSET__3bb7d87f__"